import React from "react";
import { createRoot } from "react-dom/client";
import { IntakeComponent, VARIANT_INITIAL } from './components/IntakeComponent';
import "./style/css/style.css";
import "./style/scss/style.scss";
import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from './theme/AFCS';
import { FormDataProvider } from './contexts/FormDataContext';
import "./scripts/afcs/header/index"
import { SubscriberLoginForm } from './components/JobSeekerLoginForm';


const App = ({children}) => {
  return (
    <ThemeProvider theme={theme}>
      <FormDataProvider>
        <CssBaseline/>
        {children}
      </FormDataProvider>
    </ThemeProvider>
  );
};
const container = document.getElementById("intakeApp");
if (container) {
  const root = createRoot(container);
  root.render(
    <App>
      <IntakeComponent/>
    </App>
  );
}
const loginContainer = document.getElementById("intakeAppSubscriberLogin");
if (loginContainer) {
  const root = createRoot(loginContainer);
  root.render(
    <App>
      <SubscriberLoginForm/>
    </App>
  );
}
const containerIntakeInitial = document.getElementById("intakeAppInitial");
if (containerIntakeInitial) {
  const rootIntakeInitial = createRoot(containerIntakeInitial);
  rootIntakeInitial.render(
    <App>
      <IntakeComponent variant={VARIANT_INITIAL}/>
    </App>
  );
}
